export const MENU_ITEMS: any[] = [
  {
    title: 'Dashboard',
    icon: 'home',
    link: '/dashboard'
  }
];
